export default {
    ADDRESS: {
        type: 'address',
        icon: 'pin',
        label: 'Addresses',
    },
    STOP: {
        type: 'stop',
        icon: 'stop',
        label: 'Stops',
    },
    TRIP: {
        type: 'trip',
        icon: '',
        label: 'TripId',
    },
    ROUTE: {
        type: 'route',
        icon: '',
        label: 'Routes',
    },
    TRAIN: {
        type: 'train',
        icon: '',
        label: 'Trains',
    },
    BUS: {
        type: 'bus',
        icon: '',
        label: 'Buses',
    },
    FERRY: {
        type: 'ferry',
        icon: '',
        label: 'Ferries',
    },
    BLOCK: {
        type: 'block',
        icon: '',
        label: 'Blocks',
    },
    CONTROL_ALERTS_ROUTES: {
        type: 'control-alerts-routes',
        icon: '',
        label: 'Routes',
    },
    CONTROL_ROUTE: {
        type: 'control-route',
        icon: '',
        label: 'Routes',
    },
    CONTROL_ROUTE_VARIANT: {
        type: 'control-route-variant',
        icon: '',
        label: 'Route variants',
    },
    STOP_GROUP: {
        type: 'stop-group',
        icon: '',
        label: 'Stop groups',
    },
    STOP_GROUP_MERGED: {
        type: 'stop-group-merged',
        icon: '',
        label: 'Stop groups',
    },
    STOP_MESSAGE: {
        type: 'stop-message',
        icon: '',
        label: 'Stop messages',
    },
    STOP_DISRUPTION: {
        type: 'stop-disruption',
        icon: '',
        label: 'Disruption',
    },
    STOP_IN_GROUP: {
        type: 'stop-in-group',
        icon: 'stop',
        label: 'Stop in groups',
    },
};
